/* 将对象里的值都设置为空字符串或空数组 */
export function resetObj(obj) {
    let newObj = {};
    for (var key in obj) {
        if (Object.prototype.toString.call(obj[key]) == "[object Object]") {
            newObj[key] = resetObj(obj[key])
        } else if (Object.prototype.toString.call(obj[key]) == "[object Array]") {
            newObj[key] = []
        } else {
            newObj[key] = ''
        }
    }
    return newObj;
}

export function resetObj2(obj) {
    for (var key in obj) {
        if (Object.prototype.toString.call(obj[key]) == "[object Object]") {
            obj[key] = resetObj(obj[key])
        } else if (Object.prototype.toString.call(obj[key]) == "[object Array]") {
            obj[key] = []
        } else {
            obj[key] = ''
        }
    }
    return obj
}
export function checkUnitPrice(rule, value, callback) {
    if (!value) {
        callback(new Error('请填写单价'));
    } else if (isNaN(value)) {
        callback(new Error('请输入数字值'));
    } else {
        if (value <= 0) {
            callback(new Error('必须大于0'));
        } else {
            callback();
        }
    }

}
export const ufunction = {

    getSysId() {
        return 1 //当前系统为生产模块 是1 
    },
    getAdminId() {
        let oUser = this.getCookie('userInfo_multiActive') ? JSON.parse(this.getCookie('userInfo_multiActive')) : {}
        return oUser.adminId
    },
    wordData: {
        order_type: [{
            text: '包工包料',
            value: 'oem'
        }, {
            text: '来料加工',
            value: 'cmt'
        }],
        order_sort: [{
                value: "1",
                text: '发单时间由近及远'
            },
            {
                value: "2",
                text: '发单时间由远及近'
            },
            {
                value: "3",
                text: '交货时间从后往前'
            },
            {
                value: "4",
                text: '交货时间从前往后'
            },
            {
                value: "5",
                text: '工期由长到短'
            },
            {
                value: "6",
                text: '工期由短到长'
            }
        ],
        order_status: [{
                text: '待接单',
                value: '10100'
            },
            {
                text: '接单超时',
                value: '10200'
            },
            {
                text: '待选生产商',
                value: '10300'
            },
            {
                text: '待品牌商补充详细资料',
                value: '10500'
            },
            {
                text: '待品牌商上传合同',
                value: '12100'
            },
            {
                text: '待生产商确认合同',
                value: '12300'
            },
            {
                text: '待品牌商上传定金支付凭证',
                value: '12900'
            },
            {
                text: '待生产商确认定金支付凭证',
                value: '13000'
            },
            {
                text: '待生产商交付大货',
                value: '13700'
            },
            {
                text: '待品牌商验收成衣',
                value: '16700'
            },
            {
                text: '待生产商确认验收结果',
                value: '18300'
            },
            {
                text: '待品牌商支付交货款',
                value: '18700'
            },
            {
                text: '待生产商确认交货款',
                value: '18800'
            },
            {
                text: '待品牌商支付尾款',
                value: '19300'
            },
            {
                text: '待生产商确认尾款',
                value: '19400'
            },
            {
                text: '待订单评价',
                value: '19600'
            },
            {
                text: '品牌商已评价',
                value: '19710'
            },
            {
                text: '生产商已评价',
                value: '19720'
            },
            {
                text: '订单完成',
                value: '19800'
            },
            {
                text: '已取消',
                value: '19900'
            }
        ]
    },
    isEmptyObject: function(obj) {
        for (var key in obj) {
            return false; //返回false，不为空对象
        }
        return true; //返回true，为空对象
    },
    modelLists: [{
        "photo": "https://photo.bujuyun.com/../model/6N6A8914.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 37
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8793.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 35
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8813.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 34
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8827.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 31
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8858.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 26
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8874.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 24
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8770.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 20
    }, {
        "photo": "https://photo.bujuyun.com/../model/6N6A8768.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 18
    }, {
        "photo": "https://photo.bujuyun.com/../model/G1C1046.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 13
    }, {
        "photo": "https://photo.bujuyun.com/../model/G1C1050.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 12
    }, {
        "photo": "https://photo.bujuyun.com/../model/G2L5212.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 11
    }, {
        "photo": "https://photo.bujuyun.com/../model/1S4A2410.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 17
    }, {
        "photo": "https://photo.bujuyun.com/../model/1S4A0903.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 16
    }, {
        "photo": "https://photo.bujuyun.com/../model/1S4A0413.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 15
    }, {
        "photo": "https://photo.bujuyun.com/../model/1S4A0344.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 14
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1803.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 10
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1741.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 9
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1633.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 7
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1542.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 6
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1479.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 5
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1328.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 4
    }, {
        "photo": "https://photo.bujuyun.com/../model/hui_1189.jpg?x-oss-process=image/resize,m_fill,w_120,h_178",
        "id": 2
    }],
    rules: {
        orderBand: [{
            required: true,
            message: '请选择品牌',
            trigger: 'blur'
        }],
        quantityStr: [{
            required: true,
            message: '请选择品质要求',
            trigger: 'blur'
        }],
        orderMaterialReadyTime: [{
            required: true,
            message: '请选择面辅料到期时间',
            trigger: 'blur'
        }],
        orderDeliveryTime: [{
            required: true,
            message: '请选择大货交期时间',
            trigger: 'blur'
        }],
        style1: [{
            required: true,
            message: '请选择款式一级分类',
            trigger: 'blur'
        }],
        style2: [{
            required: true,
            message: '请选择款式二级分类',
            trigger: 'blur'
        }],
        style3: [{
            required: true,
            message: '请选择款式三级分类',
            trigger: 'blur'
        }],
        fabricSupply: [{
            required: true,
            message: '请选择面辅料提供情况',
            trigger: 'blur'
        }],
        orderTakingEndTime: [{
            required: true,
            message: '请选择抢单截止日期',
            trigger: 'blur'
        }],
        fabricFreightChargeBearer: [{
            required: true,
            message: '请选择面辅料运费承担方',
            trigger: 'blur'
        }],
        highFreightChargeBearer: [{
            required: true,
            message: '请选择大货运费承担方',
            trigger: 'blur'
        }],
        ces: [{
            required: true,
            message: 'ces',
            trigger: 'blur'
        }],
        orderUnitPrice: [{
            required: true,
            validator: checkUnitPrice,
            trigger: 'change',
        }]
    }
}
